import { extractPersonFromJsonLd } from './index';
export const extractPersonAssignedTo = jsonLd => {
  const assignedTo = jsonLd['atlassian:assignedTo'];
  if (assignedTo) {
    return extractPersonFromJsonLd(assignedTo);
  }
};